import React from "react";

export default function MobileAppSection() {
  return (
    // <div
    //   className="mobileAppSec lazyload"
    //   data-src="assets/images/mobileappPetrn.jpg"
    // >
    <div
      className="mobileAppSec"
      style={{
        backgroundImage: "url("+`${process.env.PUBLIC_URL}`+"/assets/images/mobileappPetrn.jpg)",
      }}
    >
      <div className="container">
        <div className="mobileApppnel">
          <div className="media">
            <div className="mobileimg">
              {/* <img src="assets/images/mobileapp.png" alt="" /> */}
              <img src={`${process.env.PUBLIC_URL}/assets/images/mobileapp.png`} alt="" />
            </div>
            <div className="media-object pagehding">
              <h2>
                Download the App <br /> to Explore Luxury <br /> Jewellery.
              </h2>
              <ul>
                <li>
                  <a href="https://apps.apple.com/us/app/jwlbook-jewelry/id6744888223" target="_blank" rel="noreferrer">
                    {/* <img src="assets/images/appimge1.png" alt="" /> */}
                    <img src={`${process.env.PUBLIC_URL}/assets/images/appimge1.png`} alt="" />
                  </a>
                </li>
                <li>
                  <a href="https://play.google.com/store/apps/details?id=com.jwlbookllc.jwlbook" target="_blank" rel="noreferrer">
                    {/* <img src="assets/images/appimge2.png" alt="" /> */}
                    <img src={`${process.env.PUBLIC_URL}/assets/images/appimge2.png`} alt="" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
